import { Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'acs-ok-dialog',
  templateUrl: './ok-dialog.component.html'
})
export class OkDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; content: string; contentSeparated: string[] },
    private dialogRef: MatDialogRef<OkDialogComponent>
  ) {}

  public onNoClick(): void {
    this.dialogRef.close();
  }
}
